module.exports = __webpack_public_path__ + "static/media/confeitaria-marina-flyer-768x591.4aad53d9.jpg";